import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export const publicRouter = [
	{
		path: '/',
		redirect: 'home'
	},
	{
		path: '/login',
		name: 'login',
		meta: {
			title: '登录'
		},
		component: () => import(/* webpackChunkName: "login" */ './views/login/index')
	},
	{
		path: '/room-query',
		name: 'room-query',
		meta: {
			title: '考场查询'
		},
		component: () => import(/* webpackChunkName: "room-query" */ './views/roomQuery/index')
	},
	{
		path: '/inventory-query',
		name: 'inventory-query',
		meta: {
			title: '监考证查询'
		},
		component: () => import(/* webpackChunkName: "inventory-query" */ './views/inventoryQuery/index')
	},
	{
		path: '/certificate-query',
		name: 'certificate-query',
		meta: {
			title: '证书查询'
		},
		component: () => import(/* webpackChunkName: "certificate-query" */ './views/certificateQuery/index')
	},
	{
		path: '/certificate-query/:id(\\d+)',
		name: 'certificate-query-detail',
		meta: {
			title: '证书查询详情'
		},
		component: () => import(/* webpackChunkName: "certificate-query-detail" */ './views/certificateQueryDetail')
	},
	{
		path: '/certificate-detail/:id(\\d+)',
		name: 'certificate-detail',
		meta: {
			title: '证书详情'
		},
		component: () => import(/* webpackChunkName: "certificate-detail" */ './views/certificateDetail')
	},
	{
		path: '/404',
		name: '404',
		component: () => import(/* webpackChunkName: "404-page" */ './views/404')
	}
];

export const userRouter = [
	{
		path: '/home',
		name: 'home',
		meta: {
			title: '个人中心'
		},
		component: () => import(/* webpackChunkName: "home" */ './views/home/index')
	},
	{
		path: '/sign-up-detail/:id(\\d+)',
		name: 'sign-up-detail',
		meta: {
			title: '报名详情'
		},
		component: () => import(/* webpackChunkName: "sign-up-detail" */ './views/signUpDetail')
	},
	{
		path: '/sign-up',
		name: 'sign-up',
		meta: {
			title: '在线报名'
		},
		component: () => import(/* webpackChunkName: "sign-up" */ './views/signUp/index')
	},
	{
		path: '/modify-personal-info',
		name: 'modify-personal-info',
		meta: {
			title: '修改个人信息'
		},
		component: () => import(/* webpackChunkName: "modify-personal-info" */ './views/modifyPersonalInfo/index')
	},
	{
		path: '/modify-contact-info',
		name: 'modify-contact-info',
		meta: {
			title: '修改联系方式'
		},
		component: () => import(/* webpackChunkName: "modify-contact-info" */ './views/modifyContactInfo/index')
	},
	{
		path: '/modify-password',
		name: 'modify-password',
		meta: {
			title: '修改密码'
		},
		component: () => import(/* webpackChunkName: "modify-password" */ './views/modifyPassword/index')
	},
	{
		path: '/safe-setting',
		name: 'safe-setting',
		meta: {
			title: '安全设置'
		},
		component: () => import(/* webpackChunkName: "safe-setting" */ './views/safeSetting/index')
	},
	{
		path: '/pay/:id(\\d+)',
		name: 'pay',
		meta: {
			title: '支付'
		},
		component: () => import(/* webpackChunkName: "pay" */ './views/pay/index')
	},
	{
		path: '*',
		redirect: '/404'
	}
];

export default new Router({
	scrollBehavior(to, from, savedPosition) {
		return {
			x: 0,
			y: 0
		};
	},
	routes: publicRouter
});
